import jQuery from 'jquery';

export default (function ($) {
  // Maskiering einschalten
  $.fn.mask = function (oSettings) {
    if ($(this).data('bXMask')) {
      return;
    }
    if (this.attr('style')) {
      $(this).data('oldStyle', this.attr('style'));
    }
    if (this.attr('class')) {
      $(this).data('oldClass', this.attr('class'));
    }
    if ($(this).data('RandId') !== undefined) {
      $(this).unmask();
    }

    var oMask = {};
    oMask.defaults = {
      timeout: 50000,
      showIcon: true,
      position: null,
      css: null,
    };

    // Optionen
    var oOptions = $.extend({}, oMask.defaults, $.extend({}, oSettings));
    if (oOptions.css == null) {
      oMask.cssXMask = {
        '-moz-opacity': '0.4',
        opacity: '.40',
        filter: 'alpha(opacity=40)',
        backgroundColor: '#ffffff',
        zoom: '1',
        position: 'relative',
      };
    } else {
      oMask.cssXMask = oOptions.css;
    }

    oMask.RandId = Math.floor(Math.random() * 1000);
    $(this).data('RandId', oMask.RandId);

    if (this.attr('style')) {
      $(this).data('oldStyle', this.attr('style'));
    }
    if (this.attr('class')) {
      $(this).data('oldClass', this.attr('class'));
    }
    // Element maskieren
    if (!this.hasClass('x-mask')) {
      this.addClass('x-mask').css(oMask.cssXMask);
      $(this).data('bXMask', true);
    }

    if (oOptions.showIcon) {
      let sElemXCenter;
      let sElemYCenter;
      var top;
      var left;
      if (oOptions.position) {
        sElemXCenter = Math.floor(oOptions.position.left);
        sElemYCenter = Math.floor(oOptions.position.top);
        top = `${sElemYCenter}px`;
        left = `${sElemXCenter}px`;
      } else {
        sElemXCenter = parseFloat(this.width()) / 2;
        sElemYCenter = parseFloat(this.height()) / 2;
        if (sElemYCenter > 300) {
          sElemYCenter = 150;
        }
        top = `${sElemYCenter}px`;
        left = `${sElemXCenter}px`;
        if (sElemYCenter === 0 || sElemXCenter === 0) {
          top = '40%';
          left = '50%';
        }
      }
      var iRandomIcon = `qLoadingIcon-${oMask.RandId}`;
      $(this).data('jqLoadingIcon', iRandomIcon);
      var oIconDiv = `<span id="${iRandomIcon}" class="icomoon icomoon-2x icomoon-spin icon-spinner2" style="position:absolute;top:${top};left:${left};z-index:9999;" />`;

      if ($(document.body)) {
        var bIsInlineTag = false;
        if ($(this).attr('tagName')) {
          var sTagName = $(this).attr('tagName').toLowerCase();
          var inlineTags = ['a', 'abbr', 'acronym', 'b', 'big',
            'b', 'big', 'cite', 'code', 'dfn', 'em', 'font', 'i',
            'img', 'input', 'q', 's', 'samp', 'small', 'span',
            'strike', 'strong', 'sub', 'sup', 'tt', 'u', 'button'];
          for (var i = 0; i < inlineTags.length; i += 1) {
            if (sTagName === inlineTags[i]) {
              bIsInlineTag = true;
              break;
            }
          }
        }
        if (bIsInlineTag) {
          $(document.body).append(oIconDiv);
        } else {
          $(this).append(oIconDiv);
        }
      }
    }
    // Timer einschalten
    if (oOptions.timeout > 0) {
      var target = this;
      var oTimeOut = window.setTimeout(() => {
        $(target).unmask();
      }, oOptions.timeout);
      $(this).data('oTimeOut', oTimeOut);
    }
  };

  // Maskierung ausschalten
  $.fn.unmask = function () {
    if ($(this).data('RandId') === undefined) {
      return;
    }
    if ($(this).data('bXMask')) {
      this.removeClass('x-mask');
      $(this).data('bXMask', false);
    }
    // Class-Attribute
    this.removeAttr('class');
    if ($(this).data('oldClass')) {
      this.attr('class', $(this).data('oldClass'));
    }
    // Style-Attribute
    this.removeAttr('style');
    if ($(this).data('oldStyle')) {
      this.attr('style', $(this).data('oldStyle'));
    }
    // Icon wieder löschen
    if ($(this).data('jqLoadingIcon')) {
      var sIconId = $(this).data('jqLoadingIcon');
      if ($(`#${sIconId}`)) {
        $(`#${sIconId}`).remove();
      }
    }
    // Timeout ausschalten
    if ($(this).data('oTimeOut')) {
      window.clearTimeout($(this).data('oTimeOut'));
    }
  };
}(jQuery));
